import { useEffect, useState } from "react";
import AIAgentService from "../../services/Department/AIAgentService";

function AIAgent({}) {
  const [agentId, setAgentId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchAgentId();
  }, []);

  const fetchAgentId = () => {
    setIsLoading(true);
    AIAgentService.GetByDepartmentId()
      .then((response) => {
        
        const id = response.data;
        setAgentId(id);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching AI Agent ID:", error);
        setIsLoading(false);
      });
  };

/*   useEffect(() => {
    if (agentId) {
      const script = document.createElement("script");
      script.src = "https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1";
      script.async = true;
      document.body.appendChild(script);
    }
  }, [agentId]); */

  if (!agentId || isLoading) return null;

  return (
    <df-messenger
      project-id="circleram-dl"
      agent-id={agentId}
      language-code="en"
      max-query-length="-1"
      allow-feedback="all"
    >
      <df-messenger-chat-bubble
        chat-title="Department AI Agent"
        chat-title-icon="https://xyz.circleram.com/shareddirectory/images/Circleram-logo-mark-white.png"
        allow-fullscreen="small"
      >
      </df-messenger-chat-bubble>
    </df-messenger>
  );
}

export default AIAgent;
